import api from './client';

export const initiatePayment = (data) =>
  api.post('/payments/initiate', data).then(r => r.data);

export const getPayments = () =>
  api.get('/payments').then(r => r.data);

export const getPayment = (id) =>
  api.get(`/payments/${id}`).then(r => r.data);

export const refundPayment = (id, reason) =>
  api.post(`/payments/${id}/refund`, { reason }).then(r => r.data);
